import React from 'react'
import { func, bool, object, string } from 'prop-types'
import {
  PASSWORD_CHANGE_TITLE,
  GENERIC_PASSWORD_CHANGE_ERROR,
  PASSWORD_CHANGE_ACTION
} from '../../constants/ui.labels'
import {
  Base,
  ContentHeader,
  PasswordChangeFieldGroup,
  Error
} from '../../components'
import { default as redirectToLogin } from '../../utils/redirect/redirectTo'
import mapError from '../../utils/mapError/userManagement'
import SecureForm from '../../components/SecureForm'
import NoRecaptchaSecureForm from '../../components/NoRecaptchaSecureForm'

class PasswordResetConfirmation extends React.Component {
  state = {
    formData: {
      password: '',
      passwordConfirmation: '',
      error: null,
      isValid: false
    }
  }

  onFormChange = formData => this.setState({ formData })

  getErrorMessage = errorCode =>
    this.state.formData.error ||
    (errorCode && mapError(errorCode, GENERIC_PASSWORD_CHANGE_ERROR)) ||
    null

  onFormSubmit = recaptchaResponse => {
    const { password, passwordConfirmation } = this.state.formData
    const { match, onSubmit } = this.props
    onSubmit({
      password,
      passwordConfirmation,
      recaptchaResponse: recaptchaResponse,
      token: match.params.token
    })
    this.setState({ displayToastError: true })
  }

  createToastError = errorCode => {
    return <Error message={this.getErrorMessage(errorCode)} />
  }

  render() {
    const {
      processed,
      errorCode,
      siteKey,
      disabledForm,
      onExecuteRecaptcha
    } = this.props
    return (
      <Base.Centered>
        {!processed ? (
          <React.Fragment>
            <ContentHeader title={PASSWORD_CHANGE_TITLE} />
            {(this.state.formData.error && !this.state.formData.isValid) ||
            this.state.displayToastError
              ? this.createToastError(errorCode)
              : null}
            {siteKey !== '' ? (
              <SecureForm
                disabledForm={disabledForm}
                onSubmit={this.onFormSubmit}
                onExecuteRecaptcha={onExecuteRecaptcha}
                isFormValid={this.state.formData.isValid}
                submitLabel={PASSWORD_CHANGE_ACTION}
                siteKey={siteKey}
              >
                <PasswordChangeFieldGroup
                  formData={this.state.formData}
                  onFormChange={this.onFormChange}
                  disabledForm={disabledForm}
                />
              </SecureForm>
            ) : (
              <NoRecaptchaSecureForm
                disabledForm={disabledForm}
                onSubmit={this.onFormSubmit}
                isFormValid={this.state.formData.isValid}
                submitLabel={PASSWORD_CHANGE_ACTION}
              >
                <PasswordChangeFieldGroup
                  formData={this.state.formData}
                  onFormChange={this.onFormChange}
                  disabledForm={disabledForm}
                />
              </NoRecaptchaSecureForm>
            )}
          </React.Fragment>
        ) : (
          redirectToLogin()
        )}
      </Base.Centered>
    )
  }
}

PasswordResetConfirmation.propTypes = {
  onSubmit: func.isRequired,
  onExecuteRecaptcha: func.isRequired,
  siteKey: string.isRequired,
  errorCode: string,
  processed: bool.isRequired,
  disabledForm: bool.isRequired,
  match: object
}

PasswordResetConfirmation.defaultProps = {
  errorCode: null,
  disabledForm: false
}

export default PasswordResetConfirmation
